import React from "react";
import "./css/title.css";

function Title() {
  return (
    <nav className="navbar">
      <div className="logo-container">
        <h1 className="logo-text">
          Opinion<span>.io</span>
        </h1>
      </div>
    </nav>
  );
}

export default Title;
